import { render, staticRenderFns } from "./Lockers.vue?vue&type=template&id=3b424712"
import script from "./Lockers.vue?vue&type=script&lang=js"
export * from "./Lockers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports